var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "transcript-ring-gauge", style: _vm.ringStyle },
    [
      _c(
        "svg",
        { attrs: { viewBox: "0 0 48 48", width: "100%", height: "100%" } },
        [
          _c("circle", {
            attrs: {
              cx: "24",
              cy: "24",
              r: 20,
              fill: "none",
              stroke: _vm.trackColor,
              "stroke-width": "5"
            }
          }),
          _c("circle", {
            attrs: {
              cx: "24",
              cy: "24",
              r: 20,
              fill: "none",
              stroke: _vm.color,
              "stroke-width": "5",
              "stroke-linecap": "round",
              "stroke-dasharray": _vm.ringCircumference,
              "stroke-dashoffset": _vm.ringOffset,
              transform: "rotate(-90 24 24)"
            }
          })
        ]
      ),
      _c(
        "span",
        { staticClass: "transcript-ring-gauge__content" },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }